module.exports = __webpack_public_path__ + "img/Phone.0280205a.svg";